import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import animationData from "../asset/Animation - 1742479130000.json"; // Ensure correct path

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-400 dark:bg-gray-300 text-gray-800 dark:text-white px-4">
      <motion.div
        className="w-72 h-72 flex-shrink-0"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
      >
        <Lottie animationData={animationData} loop={true} className="p-0 m-0" />
      </motion.div>
      
      {/* Removed Extra Space */}
      <p className="text-lg -mt-24 mb-6 text-center text-red-800">
        Oops! The page you are looking for does not exist.
      </p>
      
      <Link
        to="/"
        className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow-lg hover:bg-blue-700 transition"
      >
        Go Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
